import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <rect x="3" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <rect x="9" y="4" width="3" height="15" fill="black" fillOpacity="0.6" />
      <rect x="6" y="10" width="3" height="3" fill="black" fillOpacity="0.6" />
      <path
        d="M20.1213 18.1213C20.6839 17.5587 21 16.7956 21 16V13.75C21 13.1533 20.7629 12.581 20.341 12.159C19.919 11.7371 19.3467 11.5 18.75 11.5C19.3467 11.5 19.919 11.2629 20.341 10.841C20.7629 10.419 21 9.84674 21 9.25V7C21 6.20435 20.6839 5.44129 20.1213 4.87868C19.5587 4.31607 18.7956 4 18 4H14V7H18V10H15V13H18V16H14V19H18C18.7956 19 19.5587 18.6839 20.1213 18.1213Z"
        fill="black"
        fillOpacity="0.6"
      />
    </>
  ),
  'Heading 3',
  '0 0 24 24'
);
